<template>
  <div class="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 flex items-center justify-center p-4">
    <div class="max-w-md w-full">
      <!-- Header -->
      <div class="text-center mb-8">
        <h1 class="text-4xl font-bold text-gray-800 mb-2 font-inter">reepo.io</h1>
        <p class="text-gray-600 text-lg">Admin Portal</p>
      </div>
      
      <!-- Login Form -->
      <div class="bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow duration-200 p-8">
        <form @submit.prevent="handleLogin" class="space-y-6">
          <!-- Email Field -->
          <div>
            <label for="email" class="form-label">
              Email
            </label>
            <input
              id="email"
              v-model="form.email"
              type="email"
              required
              class="form-input"
              placeholder="Enter your email"
              :disabled="isLoading"
            />
          </div>
          
          <!-- Password Field -->
          <div>
            <label for="password" class="form-label">
              Password
            </label>
            <input
              id="password"
              v-model="form.password"
              type="password"
              required
              class="form-input"
              placeholder="Enter your password"
              :disabled="isLoading"
            />
          </div>
          
          <!-- Submit Button -->
          <button
            type="submit"
            class="btn-primary w-full"
            :disabled="isLoading"
          >
            <span v-if="isLoading" class="flex items-center justify-center">
              <svg class="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              Signing In...
            </span>
            <span v-else>Sign In</span>
          </button>
        </form>
        
        <!-- Error Message -->
        <div v-if="error" class="mt-6 bg-red-50 border border-red-200 rounded-lg p-4 text-center">
          <div class="text-red-800 font-medium text-lg mb-2">❌ Login Failed</div>
          <p class="text-red-600">{{ error }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive } from 'vue'
import { useRouter } from 'vue-router'
import { useAuthStore } from '../stores/authStore.js'

// Router
const router = useRouter()

// Reactive data
const form = reactive({
  email: '',
  password: ''
})

const isLoading = ref(false)
const error = ref('')

// Methods
const handleLogin = async () => {
  isLoading.value = true
  error.value = ''
  
  try {
    const authStore = useAuthStore()
    const result = await authStore.login(form.email.trim().toLowerCase(), form.password)
    
    if (result.success) {
      // Redirect to dashboard
      router.push('/admin/dashboard')
    } else {
      error.value = result.error || 'Login failed. Please try again.'
    }
    
  } catch (err) {
    error.value = err.message || 'Login failed. Please try again.'
  } finally {
    isLoading.value = false
  }
}
</script> 